import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ValidationErrorMessage } from '@/components/shared/parts';
import { findAddressByZip } from '@/utils/address';

const ADDRESS_NOT_FOUND_MESSAGE =
  '該当する住所が見つかりませんでした。以下の住所欄を直接入力してください。';

const ADDRESS_FETCH_FAILED_MESSAGE =
  '住所の取得に失敗しました。以下の住所欄を直接入力してください。';

export const PartnerForm: React.FC = () => {
  const { register, setValue } = useFormContext();
  const [isLoading, setIsLoading] = useState(false);
  const [addressError, setAddressError] = useState<string | null>(null);

  const handlePostalCodeChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const postalCode = e.target.value;
    setValue('postalCode', postalCode);
    setAddressError(null);

    if (postalCode.length === 7) {
      setIsLoading(true);
      try {
        const address = await findAddressByZip(postalCode);
        if (!address) {
          setAddressError(ADDRESS_NOT_FOUND_MESSAGE);
          return;
        }
        setValue('prefecture', address.address1);
        setValue('city', address.address2);
        setValue('street', address.address3);
      } catch (e) {
        console.error(ADDRESS_FETCH_FAILED_MESSAGE, e);
        setAddressError(ADDRESS_FETCH_FAILED_MESSAGE);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className='mt-3'>
        <div className='mb-3'>
          <p className='small text-black mb-0'>
            氏名<span className='essential ms-2'>必須</span>
          </p>
          <input
            type='text'
            className='w-100 p-2'
            placeholder='田中太郎'
            {...register('name', { required: '氏名は必須です' })}
            autoComplete='new-off'
          />
        </div>

        <div className='mb-3'>
          <p className='small text-black mb-0'>
            氏名（カナ）<span className='essential ms-2'>必須</span>
          </p>
          <input
            type='text'
            className='w-100 p-2'
            placeholder='タナカタロウ'
            {...register('nameKana', {
              required: '氏名（カナ）は必須です',
            })}
            autoComplete='new-off'
          />
        </div>

        <div className='mb-3'>
          <p className='small text-black mb-0'>
            電話番号<span className='essential ms-2'>必須</span>
          </p>
          <input
            type='text'
            className='w-100 p-2'
            placeholder='電話番号'
            {...register('phoneNumber', { required: '電話番号は必須です' })}
            autoComplete='new-off'
          />
        </div>

        <div className='mb-3'>
          <p className='small text-black mb-0'>
            住所<span className='essential ms-2'>必須</span>
          </p>
          <input
            type='text'
            className='w-100 p-2 mb-1'
            placeholder='郵便番号(-は不要です)'
            {...register('postalCode', { required: '郵便番号は必須です' })}
            onChange={handlePostalCodeChange}
            autoComplete='new-off'
          />
          {addressError && <ValidationErrorMessage message={addressError} />}
          {isLoading && <p>Loading...</p>}
          <input
            type='text'
            className='w-100 p-2 mb-1'
            placeholder='都道府県'
            {...register('prefecture', { required: '都道府県は必須です' })}
            autoComplete='new-off'
          />
          <input
            type='text'
            className='w-100 p-2 mb-1'
            placeholder='市区町村'
            {...register('city', { required: '市区町村は必須です' })}
            autoComplete='new-off'
          />
          <input
            type='text'
            className='w-100 p-2 mb-1'
            placeholder='住所1'
            {...register('street', { required: '住所1は必須です' })}
            autoComplete='new-off'
          />
          <input
            type='text'
            className='w-100 p-2'
            placeholder='建物名・部屋（任意）'
            {...register('building')}
            autoComplete='new-off'
          />
        </div>

        <p className='small mb-0 text-black'>会社名</p>
        <p className='small mb-1'>会社名または団体名など</p>
        <input
          type='text'
          className='w-100 p-2'
          placeholder='会社名または団体名などを入力'
          {...register('companyName')}
          autoComplete='new-off'
        />
      </div>
    </>
  );
};
